import { useState } from "react";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { form, initialValues, vendorValidations } from "./vendor-schema";

import VendorInfo from "./components/VendorInfo";
import { Layout } from "ui-components/Layout";
import { useLocation } from "react-router-dom";
import { editVendor } from "services/data.internal.service";
import { getVendorByCode } from "services/data.internal.service";
import { SaveButton } from "ui-components/Form";
import { Success, Error_ } from "ui-components/Alert";

function EditVendor() {
  const location = useLocation();
  const { vendorCode, customerCode } = location?.state ?? {};
  const { formRender } = form;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  useQuery({
    queryKey: ["vendor", { vendorCode, customerCode }],
    queryFn: () => getVendorByCode({ vendorCode, customerCode }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });
  const editVendorMutation = useMutation(editVendor, {
    onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
    onError,
  });
  const formInstance = useForm({
    defaultValues: initialValues,
    values: formValues,
    resolver: yupResolver(vendorValidations),
  });
  const {
    register,
    control,
    formState: { errors, isDirty, isSubmitting },
    handleSubmit,
  } = formInstance;

  const infoProps = {
    formRender,
    register,
    control,
    errors,
    mode: "EDIT",
  };

  const onSubmit = (data) => {
    editVendorMutation.mutate(data, { onSuccess: () => queryClient.invalidateQueries(["vendor"]) });
  };

  return (
    <Layout>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        {alert}
        <VendorInfo {...infoProps} />
        <SaveButton label="save" disabled={!isDirty || isSubmitting} url="/setup/vendor" />
      </form>
    </Layout>
  );
}

export default EditVendor;
